// @flow
import {Error} from '../utils/errors';

/**
 * Textos del overlay de error embebidos en el bundle. Sirven de red de seguridad cuando el
 * fichero de idioma que se descarga de `assetsCDN` es antiguo o no trae la clave: sin esto
 * la plantilla imprime `undefined` en pantalla.
 */
const FALLBACK_TEXTS = {
  es: {
    next_available: 'Próximamente',
    days: 'Días',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    will_be_available: 'Estará disponible:'
  },
  en: {
    next_available: 'Coming soon',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    will_be_available: 'Will be available:'
  }
};

/**
 * Texto traducido del bloque `error`, con respaldo en los textos embebidos.
 * @param {string} key clave dentro de `translations.error`
 * @returns {string} texto a pintar, nunca `undefined`
 */
function errorText(key: string): string {
  try {
    const value = window.translations['error'][key];
    if (value !== undefined && value !== null && String(value).length) return value;
  } catch (e) {
    // el idioma no se ha cargado todavía
  }
  let lang = 'en';
  try {
    lang = navigator.language.split(/-|_/)[0];
  } catch (e) {
    // do nothing
  }
  const fallback = FALLBACK_TEXTS[lang] || FALLBACK_TEXTS.en;
  return fallback[key] !== undefined ? fallback[key] : '';
}

/**
 * Fecha de publicación en formato `dd/mm/aaaa hh:mm`, en la hora local del espectador.
 * @param {Date} date fecha de publicación
 * @returns {string} fecha formateada, o cadena vacía si no hay fecha válida
 */
function formatPublishDate(date: ?Date): string {
  if (!(date instanceof Date) || isNaN(date.getTime())) return '';
  const pad = value => String(value).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/**
 * Render error
 * @param {string} targetId html tag id
 * @param {Error} message message
 * @param {string} image show image as background
 * @param {string} text show text message
 * @param {boolean} activeBlur activeBlur
 * @param {Date} publishDate publishDate
 * @returns {any} none
 */
function render(targetId: string, message?: Error, image?: string, text: string, activeBlur?: boolean, publishDate?: Date): void {
  const doc = document.getElementById(targetId);
  let html = '<div class="ivc-error-root"><div id="error-background"></div><div class="ivc-playkit error-view">';
  if(message !== Error.NOT_AVAILABLE_YET) {
    html += ``;
    html += `<div class="error-container">`;
    if (text != null && text.length) {
      try {
        const translated = window.translations['error'][text];
        if (translated !== undefined && translated !== null && String(translated).length) text = translated;
      } catch (e) {
        // do nothing
      }
      html += `<div class="error-title">${text}</div>`;
    }
    html += `</div>`;
    doc.innerHTML = html + '</div></div>';
  }else{
    html += `
      <div class="error-container">
        <div class="error-title">${errorText('next_available')}</div>
        
        <div class="countdown">
          <div class="item">
            <div id="days"></div>
            <label>${errorText('days')}</label>
          </div>
          <div class="item">
            <div id="hours"></div>
            <label>${errorText('hours')}</label>
          </div>
          <div class="item">
            <div id="minutes"></div>
            <label>${errorText('minutes')}</label>
          </div>
          <div class="item">
            <div id="seconds"></div>
            <label>${errorText('seconds')}</label>
          </div>
        </div>
        <div class="error-title" style="font-size: 15px; margin-top: 0px; padding-top: 0px; display: none;">${errorText('will_be_available')} ${formatPublishDate(publishDate)}</div>
      </div>
    `;
    doc.innerHTML = html + '</div></div>';
    let countdownInterval = setInterval(() => countdown(publishDate, countdownInterval), 1000);
    countdown(publishDate, countdownInterval);
  }
  
  const backgroundElement = document.getElementById('error-background');
  backgroundElement.style.width = '100%';
  backgroundElement.style.height = '100%';
  if(activeBlur !== undefined && activeBlur) {
    backgroundElement.style.filter = 'blur(13px)';
    // evita los bordes transparentes que deja el blur al recortarse contra el contenedor
    backgroundElement.style.transform = 'scale(1.1)';
  }
  if (image !== undefined && image) {
    backgroundElement.style.backgroundImage = `url('${image}')`;
    backgroundElement.style.backgroundSize = 'cover';
  } else {
    backgroundElement.style.backgroundImage = `none`;
  }
}

/**
 * countdown
 * @param {Date} date date
 * @param {any} countdownInterval countdownInterval
 * @returns {any} none
 */
function countdown(date: Date, countdownInterval: any): void {
  const targetDate = date // Your target date
  const now = new Date();
  const timeLeft = targetDate.getTime() - now.getTime();

  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  document.getElementById("days").innerHTML = String(days).padStart(2, '0');
  document.getElementById("hours").innerHTML = String(hours).padStart(2, '0');
  document.getElementById("minutes").innerHTML = String(minutes).padStart(2, '0');
  document.getElementById("seconds").innerHTML = String(seconds).padStart(2, '0');

  if (timeLeft < 0) {
    clearInterval(countdownInterval);
    document.getElementById("days").innerHTML = "00";
    document.getElementById("hours").innerHTML = "00";
    document.getElementById("minutes").innerHTML = "00";
    document.getElementById("seconds").innerHTML = "00";
  }
}

export {render};
